import { MarketingChannel } from "@redotech/redo-billing-common/marketing-channel";
import { Customer } from "@redotech/redo-customer-common/customer";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum MarketingSuppressionScope {
  TEAM = "team",
  GLOBAL = "global",
}
export enum MarketingSuppressionReason {
  PERMANENT_ERROR = "permanent_error",
  TEMPORARY_ERROR = "temporary_error",
  INVALID_CHANNEL_ID = "invalid_channel_id",
  MERCHANT = "merchant",
  SPAM_COMPLAINT = "spam_complaint",
  NATIONAL_DNC = "national_dnc",
}
export const GLOBAL_SUPPRESSION_REASONS = [
  MarketingSuppressionReason.PERMANENT_ERROR,
  MarketingSuppressionReason.INVALID_CHANNEL_ID,
  MarketingSuppressionReason.NATIONAL_DNC,
] as const;

export const marketingSuppressionSchema = z.object({
  teamId: zExt.objectId(),
  channel: createEnum(MarketingChannel),
  channelId: z.string(),
  reason: createEnum(MarketingSuppressionReason),
  count: z.number(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export type MarketingSuppression = z.infer<typeof marketingSuppressionSchema>;

export type CustomerWithSuppressionReasons = Customer & {
  emailSuppressionReasons: MarketingSuppressionReason[];
  smsSuppressionReasons: MarketingSuppressionReason[];
};
